
// change language https://medium.com/@nohanabil/building-a-multilingual-static-website-a-step-by-step-guide-7af238cc8505


export const Languages = () => {

    // Call updateContent() on page load
    window.addEventListener('DOMContentLoaded', async () => {
        const userPreferredLanguage = localStorage.getItem('language') || 'fr';
        const langData = await fetchLanguageData(userPreferredLanguage);
        updateContent(langData);
        languageSwitch();
    });

}

// Function to update content based on selected language
function updateContent(langData) {
    document.querySelectorAll('[data-i18n]').forEach(element => {
        const key = element.getAttribute('data-i18n');
        const translation = langData[key];

        if (!element.hasAttribute('data-legend')) {
        element.innerHTML = translation;
        } 
        else {
                element.setAttribute('data-legend', translation);
            }
    });
}

// Function to set the language preference
function setLanguagePreference(lang) {
    localStorage.setItem('language', lang);
    // location.reload();
}

// Function to fetch language data
async function fetchLanguageData(lang) {
    const response = await fetch(`content/languages/${lang}.json`);
    return response.json();
}

// Function to change language
async function changeLanguage(lang) {

    const fr = document.querySelector('#fr');
    const en = document.querySelector('#en');

    await setLanguagePreference(lang);
    const langData = await fetchLanguageData(lang);
    updateContent(langData);



}

function languageSwitch() {
    fr.addEventListener('click', () => changeLanguage('fr'));
    en.addEventListener('click', () => changeLanguage('en'));
}